module.exports = __webpack_public_path__ + "images/connexxion16df1a3f49f4f714795aed2491634fd7.png";